"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProvider = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function createProvider(props) {
    const CreatedContext = react_1.createContext(props);
    const ContextProvider = (_a) => {
        var { children, Component } = _a, props = tslib_1.__rest(_a, ["children", "Component"]);
        if (Component) {
            const ProviderComponent = Component;
            children = jsx_runtime_1.jsx(ProviderComponent, Object.assign({}, props, { children: children }), void 0);
        }
        return (jsx_runtime_1.jsx(CreatedContext.Provider, Object.assign({ value: Object.assign(Object.assign({}, props), { Component }) }, { children: children }), void 0));
    };
    const useCreatedContext = () => {
        return react_1.useContext(CreatedContext);
    };
    return {
        Context: CreatedContext,
        ContextProvider,
        useContext: useCreatedContext,
    };
}
exports.createProvider = createProvider;
//# sourceMappingURL=Provider.js.map